webpackJsonp([246501157640856],{

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventsPage = function EventsPage(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "events page" },
	    _react2.default.createElement(
	      "h1",
	      null,
	      "Events"
	    )
	  );
	};
	
	exports.default = EventsPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-events-js-7b366a2183c2572ef2a6.js